import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import ToastContext from '../../../../src/contexts/toast';
import { RichiestaService } from '../../../services/RichiestaService';
import Select from '../../Form/Select';
import DataTableWrapper from '../../Utility/DataTableWrapper/DataTableWrapper';
import Modal from '../../Utility/Modal/Modal';
import { FormUtility } from '../../Utility/FormUtility';

export default function ErroriIsee(props) {
  console.log('inside gestione domande');

  const toastContext = useContext(ToastContext);

  const [avviso, setAvviso] = useState(null);
  const [avvisi, setAvvisi] = useState(null);

  const richiestaService = new RichiestaService();
  const utility = new FormUtility();

  const [isModalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState(null);
  const [icona, setIcona] = useState(null);
  const [iconaColor, setIconaColor] = useState(null);
  const [content, setContent] = useState(null);
  const [hideActionButton, setHideActionButton] = useState(false);

  const [domandaId, setDomandaId] = useState(null);
  const [esitoDomanda, setesitoDomanda] = useState(null);
  const [rescheduling, setRescheduling] = useState(false);

  const dtRefIsee = useRef();

  useEffect(() => {
    setAvvisi(props.avvisi);
  }, [props.avvisi]);

  const downloadIsee = async (domandaId) => {
    await richiestaService.downloadIsee(domandaId);
  }

  const checkIsee = async (domandaId) => {
    await richiestaService.checkIsee(domandaId);
    setesitoDomanda(null);
    toastContext.success('Controllo ISEE richiesto');
    setModalOpen(false);
    dtRefIsee.current.rerenderDatatable();
    setDomandaId(null);
    setesitoDomanda(null);
    setIcona(null);
    setIconaColor(null);
    setTitle(null);
  }

  const ricontrollaTuttiIsee = async (domandaId) => {
    setRescheduling(true);
    richiestaService
      .rescheduleIsee(avviso)
      .then((resp) => {
        dtRefIsee.current.rerenderDatatable();
        toastContext.success(resp + " Isee rimessi in scheduling");
        setRescheduling(false);
      })
      .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);
        setRescheduling(false);
      });
  }

  const closeModal = async () => {
    setModalOpen(false);
    setDomandaId(null);
    setesitoDomanda(null);
    setIcona(null);
    setIconaColor(null);
    setTitle(null);
  };

  const openIseeModal = (row) => {
    let esito = row.esitoIsee
    let  esitoIsee = esito == "OK" ?  "Esito ISEE positivo" : "Esito ISEE negativo";
    let icona = esito == "OK" ?  "solid--face-smile" : "solid--face-frown";
    const iconaColor = esito == "OK" ?   "rtds-text-success-dark" : "rtds-text-warn-dark";

    const hasTechnicalError = row.erroriIsee && row.erroriIsee.some(errore => errore.tipo === "TECHINCAL");

    if (hasTechnicalError) {
        icona = "solid--exclamation-triangle";
        esitoIsee = "Errore tecnico"
    }

    setDomandaId(row.id);
    setesitoDomanda(esito);
    setIcona(icona);
    setIconaColor(iconaColor);
    setTitle(esitoIsee);
    setHideActionButton(false);
    setContent(
      <div>
        <section aria-labelledby='elencoErrori'>
         
        {esito == "KO" ? (
          <>
          <section aria-labelledby="elencoErrori">
            <h3 id="elencoErrori" className="rtds-heading-5">
              Lista errori ISEE:{" "}
            </h3>
            <ul className="">
              {row.erroriIsee.map((errore, index) => (
                <li key={errore.codice}>&#x2022;&nbsp;{errore.descrizione}</li>
              ))}
            </ul>
          </section>
          <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>
          </>
        ) : null}
        </section>
        { row.rispostaIsee &&
          <button onClick={() => downloadIsee(row.id)} className="rtds-btn rtds-btn--only-text ">
                  Scarica XML
                  <svg className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 rtds-transition-all rtds-duration-200 rtds-ease-out rtds-transform group-hover:rtds-translate-x-1" aria-hidden="true" focusable="false" role="img">
            <use href="../../icons.svg#solid--arrow-down-tray"></use>
          </svg>

          </button>
        }
      </div>
    );
  
    setModalOpen(true);
  }

  const dtOptions = useMemo(() => {
    if (!avviso) return {};

    return {
      columns: [
        {
          name: "Id domanda",
          data: "id",
          visible: true,
          sortable: false,
          searchable: false,
        },
        {
            name: "Id ISEE",
            data: "iseeId",
            visible: true,
            sortable: true,
            searchable: true,
          },
        {
          name: "Codice pratica",
          data: "codice",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "C.F. studente",
          data: "codiceFiscaleBeneficiario",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "ISEE",
          data: "esitoIsee",
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => { 
            const hasTechnicalError = row.erroriIsee && row.erroriIsee.some(errore => errore.tipo === "TECHINCAL");
            const esitoIseeText = row.esitoIsee === "OK" ? "Esito ISEE positivo" : "Esito ISEE negativo";
            const srOnlyText = row.esitoIsee === null
              ? "In attesa"
              : hasTechnicalError
              ? "Errore tecnico"
              : row.esitoIsee === "OK"
              ? "Esito positivo"
              : "Esito negativo";
            const titleText = row.esitoIsee === null
              ? "In attesa della risposta dal servizio di verifica ISEE "
              : hasTechnicalError
              ? "Errore tecnico nella verifica ISEE"
              : esitoIseeText;
            const iconName = row.esitoIsee === null
              ? "spinner"
              : hasTechnicalError
              ? "solid--exclamation-triangle"
              : row.esitoIsee === "OK"
              ? "solid--face-smile"
              : "solid--face-frown";
            return(
            <div>
              <button
                disabled={!row.esitoIsee}
                type="button"
                className={`rtds-btn rtds-btn--icon  ${ row.esitoIsee === null ? "rtds-button-inverted" : row.esitoIsee === "OK" ? "rtds-btn--success" : "rtds-btn--warn"}`}
                onClick={() => {openIseeModal(row)}}
                title={titleText}
              >
                <svg
                  className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 ${row.esitoIsee == null ? "rtds-animate-spin" : ""}`}
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${iconName}`}
                  >
                    {" "}
                  </use>
                </svg>
                <span className="rtds-sr-only">{srOnlyText}</span>
              </button>
            </div>
          )
        },
        },
      ],
      serverSide: true,
      ajax: richiestaService.getAllDt,
      ajaxParams: {
        bandoId: avviso,
        esitoIsee: 'KO',
        statiRichiesta: ['PRESENTATA', 'RINUNCIATA', 'FINANZIABILE', 'NON_FINANZIABILE', 'SOSPESA', 'IDONEA', 'NON_IDONEA'],
        iseeErroreTecnico: true,
      },
      rows: [],
      sorts: [],
      hideSearch: false,
      title: "Elenco errori",
    };
  }, [avviso]);

  return (
    <>
      <div className='rtds-container rtds-py-6'>
        <div className='rtds-grid rtds-gap-6 xl:rtds-gap-8'>
          <Select
            classDiv={"rtds-mt-0 lg:rtds-mt-0"}
            label={"Avviso"}
            id={"avvisoIsee"}
            classSelect={""}
            onChange={(event) => {
              setAvviso(event.target.value ? event.target.value : null);
            }}
            baseOption={"Nessuna selezione"}
            bindKey={"id"}
            bindValue={"nome"}
            options={avvisi}
            value={avviso || ""}
          />
        </div>
      </div>

      {avviso && <DataTableWrapper
        ref={dtRefIsee}
        dtOptions={dtOptions}
        reloadDatatable={true}
        headerButton={
        <button
          disabled={rescheduling}
          type="button"
          className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
          onClick={ricontrollaTuttiIsee}
        >
          <svg
              className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use
                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-right`}
              />
          </svg>
          Riesegui il controllo ISEE
        </button>}
      />      }

      <Modal
        isOpen={isModalOpen}
        title={title}
        iconaClass={icona}
        icona={true}
        iconaColorClass={iconaColor}
        content={content}
        onClose={() => closeModal()}
        onAction={() => checkIsee(domandaId)} 
        actionLabel='Riesegui il controllo ISEE'
        closeLabel='Chiudi'
        disabledConfirmBtn={esitoDomanda != "KO"}
        hideActionButton={hideActionButton}
      />


    </>
  );
}
